// @ts-nocheck
import type * as Types from '@lingoda/monolith-graphql/src/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type TermsAndConditionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type TermsAndConditionsQuery = {
    readonly __typename?: 'Query';
    readonly publicAgreement: {
        readonly __typename?: 'PublicAgreement';
        readonly body: string;
        readonly lastUpdatedAt: string;
        readonly pdfLink: string | null;
    };
};

export const TermsAndConditionsDocument = gql`
    query termsAndConditions {
        publicAgreement(agreementType: student_terms) {
            body
            lastUpdatedAt
            pdfLink
        }
    }
` as unknown as DocumentNode<TermsAndConditionsQuery, TermsAndConditionsQueryVariables>;
